import { render } from "./TourBookingSubBanner.vue?vue&type=template&id=3382a99f"
import script from "./TourBookingSubBanner.vue?vue&type=script&lang=js"
export * from "./TourBookingSubBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__